var els = $('[data-listing-enabled]');
if (els.length > 0) {
  require.ensure('../listings/sync_enabled_fields', function(require) {
    var SyncEnabledFields = require('../listings/sync_enabled_fields');
    return new SyncEnabledFields(els);
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/sync_enabled_fields.initializer.js